const $$nested_directory$moduleExports = (function (exports) {
 // variable;
	let months = ['Jan', 'Feb', 'Mar', 'Apr', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var a = 66;
	const b = 67;
	// function:
	function ads(arg) { return 1 }
	// class:
	class Asde { constructor() { } }
	
	console.log('>> named exports test attached');
	
	exports = { months, a, b, ads, Asde };
	
	return exports 
})({})